const inView = require('in-view')

export default class Faq {
  constructor(el) {
    this.el = el
    this.filters = el.querySelector('[data-faq-filters]')
    this.content = this.el.querySelector('[data-faq-content]')
    this.currentTag = null

    if (this.filters) {
      this.filters.addEventListener('click', (e) => {
        e.preventDefault()
        this.filters.querySelectorAll('.is-active').forEach((el) => {
          el.classList.remove('is-active')
        })

        const tag = e.target.getAttribute('data-tag')
        // Allow unselecting current tag
        if (this.currentTag === tag) {
          this.currentTag = null
          e.target.classList.remove('is-active')
          e.target.blur()
        }
        else {
          this.currentTag = tag
          e.target.classList.add('is-active')
        }
        this.update()
      })

    }

    if (window.location.hash !== '') {
      try {
        const activeDetail = el.querySelector(window.location.hash)

        if (activeDetail) {
          activeDetail.open = true
          // console.log('Opening detail', activeDetail)
          if (this.filters) {
            // assign correct active tag
            const tag = activeDetail.getAttribute('data-tags').split(',')[0]
            const filterLink = this.filters.querySelector(`a[data-tag="${tag}"]`)
            // console.log({tag, filterLink})
            filterLink.classList.add('is-active')
            filterLink.click()
            this.update()
          }
          // setTimeout(() => {
          // }, 50)
        }
      } catch (error) {
        // Simulate click on first item.
        this.filters.querySelector('a').click()
      }
    }
    else {
      // Simulate click on first item.
      this.filters.querySelector('a').click()
    }

  }

  update() {
    const items = this.content.querySelectorAll('[data-tags]')
    if (this.currentTag === null) {
      items.forEach(el => {
        el.classList.remove('hidden')
      })
    }
    else {
      items.forEach(el => {
        el.classList.toggle('hidden', (el.getAttribute('data-tags').indexOf(this.currentTag) === -1))
      })
    }
    inView('[data-animation]').check()
  }
}
